/**
 * Transcript Editor Configuration Constants
 * 
 * Centralized configuration for the transcript editor
 */

export const CONFIG = {
  // Auto-save settings
  AUTO_SAVE_DELAY: 60000, // 60 seconds in milliseconds
  
  // Undo/Redo settings
  MAX_HISTORY_SIZE: 50,
  
  // Lock management
  LOCK_CHECK_INTERVAL: 30000, // 30 seconds
  
  // Video sync settings
  VIDEO_UPDATE_INTERVAL: 100, // milliseconds
  SEEK_TIMEOUT: 5000, // 5 seconds
  SEEK_TOLERANCE: 0.1, // seconds
  
  // Keyboard shortcuts
  SKIP_FORWARD_TIME: 5, // seconds
  SKIP_BACKWARD_TIME: -5, // seconds
  FINE_TUNE_TIME: 1, // seconds
  
  // Block operations
  DEFAULT_BLOCK_DURATION: 5, // seconds for new empty blocks
  
  // Word matching
  MIN_WORD_LENGTH_FOR_PARTIAL_MATCH: 3,
  MAX_WORD_LENGTH_DIFF: 3,
  
  // Text operations
  MIN_SELECTION_LENGTH: 3,
  
  // Grouping
  SENTENCES_PER_GROUP: 8,
};

export default CONFIG;

